import { DEFAULT_LOCALE } from "../../i18n/locales";

export function mergeWithFallback(active, fallback) {
  const seen = new Set(active.map((p) => p.slug));
  const extras = fallback.filter((p) => !seen.has(p.slug));
  return [...active, ...extras];
}

export function sortProjects(arr) {
  return [...arr].sort((a, b) => {
    const fa = a.frontmatter.featured ? 1 : 0;
    const fb = b.frontmatter.featured ? 1 : 0;
    if (fa !== fb) return fb - fa;
    const oa = a.frontmatter.order ?? 9999;
    const ob = b.frontmatter.order ?? 9999;
    if (oa !== ob) return oa - ob;
    return (a.frontmatter.title || "").localeCompare(b.frontmatter.title || "");
  });
}

export function getMergedProjects(lang, content) {
  const all = content.projects || { en: [], ru: [], ko: [] };
  return sortProjects(
    mergeWithFallback(all[lang] || [], all[DEFAULT_LOCALE] || [])
  );
}
